module.exports = __webpack_public_path__ + "img/icon-views.f629a445.svg";